"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionListMobile = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Styled = require("./Styled");
var _CountryPicker = require("../CountryPicker.model");
// Components:

// Interfaces:

var OptionListMobile = exports.OptionListMobile = function OptionListMobile(_ref) {
  var label = _ref.label,
    countries = _ref.countries,
    onClickDestination = _ref.onClickDestination;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Styled.StyledLabel, null, label), /*#__PURE__*/_react["default"].createElement(StyledOtherList, null, countries.map(function (country) {
    var _country$country_code;
    return /*#__PURE__*/_react["default"].createElement(StyledOtherCountry, {
      onClick: function onClick() {
        return onClickDestination(country);
      },
      key: country.name_ru + country.country_code
    }, /*#__PURE__*/_react["default"].createElement(StyledFlag, {
      closed: country.closed,
      className: "lt-flag lt-flag-".concat(((_country$country_code = country.country_code) === null || _country$country_code === void 0 ? void 0 : _country$country_code.toLowerCase()) || 'us')
    }), /*#__PURE__*/_react["default"].createElement(CountryNameWrapper, null, /*#__PURE__*/_react["default"].createElement(_Styled.CountryName, {
      closed: country.closed
    }, country.name_ru), /*#__PURE__*/_react["default"].createElement(_Styled.Visa, {
      noVisa: country.visaAvailability === _CountryPicker.NO_VISA,
      closed: country.closed
    }, country.visaAvailability)));
  })));
};
var StyledOtherList = _styledComponents["default"].ul.withConfig({
  displayName: "OptionListmobile__StyledOtherList",
  componentId: "sc-3itz2z-0"
})([""]);
var StyledOtherCountry = _styledComponents["default"].li.withConfig({
  displayName: "OptionListmobile__StyledOtherCountry",
  componentId: "sc-3itz2z-1"
})(["display:flex;height:48px;&:hover{cursor:pointer;}"]);
var CountryNameWrapper = _styledComponents["default"].div.withConfig({
  displayName: "OptionListmobile__CountryNameWrapper",
  componentId: "sc-3itz2z-2"
})(["display:flex;flex-direction:column;white-space:nowrap;"]);
var StyledFlag = _styledComponents["default"].div.withConfig({
  displayName: "OptionListmobile__StyledFlag",
  componentId: "sc-3itz2z-3"
})(["margin-right:8px;", ""], function (_ref2) {
  var closed = _ref2.closed;
  return closed && "\n    filter: grayscale(1);\n    opacity: 0.6;\n  ";
});